import React from 'react';
import { BoxWrapper } from 'components/Base';
import { makeStyles, Grid } from '@material-ui/core';
import PasswordUpdateForm from './PaswordUpdateForm';

const useStyles = makeStyles({
  container: {
    padding: '1rem'
  },
  itemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginBottom: '1rem'
  },
  item: {
    display: 'flex',
    fontSize: '1rem',
    alignItems: 'baseline'
  },
  label: {
    fontWeight: 600,
    width: '60px'
  },
  value: {}
});

interface AccountSettingsProps {
  advisor: any;
}

const AccountSettings = ({ advisor }: AccountSettingsProps) => {
  const classes = useStyles();

  return (
    <BoxWrapper title="Account Settings">
      <div className={classes.container}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <div className={classes.itemWrapper}>
              <div className={classes.item}>
                <div className={classes.label}>Name:</div>
                <div className={classes.value}>{advisor.full_name}</div>
              </div>
              <div className={classes.item}>
                <div className={classes.label}>Email:</div>
                <div className={classes.value}>{advisor.email}</div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <PasswordUpdateForm />
          </Grid>
        </Grid>
      </div>
    </BoxWrapper>
  );
};

export default AccountSettings;
